import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { heroImage, businessInfo } from '../data/mock';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-[55vh] min-h-[380px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src={heroImage}
          alt="Marina Homes luxury apartment"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3">
          Welcome to <span className="text-amber-400">{businessInfo.name}</span>
        </h1>
        <p className="text-base md:text-lg text-gray-200 mb-4 max-w-2xl mx-auto">
          Experience comfort and luxury in our beautifully designed serviced apartments. 
          Your home away from home awaits.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 mb-4">
          <button 
            onClick={scrollToContact}
            className="bg-amber-600 hover:bg-amber-700 text-white px-5 py-2.5 rounded-lg font-semibold transition-all duration-300 hover:scale-105 shadow-lg text-sm"
          >
            Get in Touch
          </button>
          <button 
            onClick={() => document.getElementById('gallery').scrollIntoView({ behavior: 'smooth' })}
            className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-5 py-2.5 rounded-lg font-semibold transition-all duration-300 border-2 border-white/30 text-sm"
          >
            View Gallery
          </button>
        </div>

        {/* Quick Contact */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 text-white text-sm">
          <a 
            href={`tel:${businessInfo.phone}`}
            className="flex items-center space-x-2 hover:text-amber-400 transition-colors"
          >
            <Phone size={16} />
            <span>{businessInfo.phone}</span>
          </a>
          <span className="hidden sm:inline text-white/50">|</span>
          <a 
            href={`mailto:${businessInfo.email}`}
            className="flex items-center space-x-2 hover:text-amber-400 transition-colors"
          >
            <Mail size={16} />
            <span>{businessInfo.email}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
